module.exports = __webpack_public_path__ + "img/4.895ba6e0.jpg";